'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.register = register;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _addons = require('@storybook/addons');

var _addons2 = _interopRequireDefault(_addons);

var _LocalePanel = require('./containers/LocalePanel');

var _LocalePanel2 = _interopRequireDefault(_LocalePanel);

var _shared = require('../shared');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function register() {
    _addons2.default.register(_shared.ADDON_ID, function () {
        _addons2.default.addPanel(_shared.PANEL_ID, {
            title: 'Locales',
            render: function render(props) {
                return _react2.default.createElement(_LocalePanel2.default, {
                    key: props && (typeof props === 'undefined' ? 'undefined' : _typeof(props)) === 'object' && props.key || undefined,
                    active: !props || props.active,
                    channel: _addons2.default.getChannel()
                });
            }
        });
    });
}